import styled, { css, keyframes } from 'styled-components'

import { IconV2 } from '../Icon'

const InAnimationOverlay = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
`

const OutAnimationOverlay = keyframes`
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
`

const InAnimationDialog = keyframes`
  0% {
    transform: translateY(-50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`

const OutAnimationDialog = keyframes`
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-50px);
    opacity: 0;
  }
`

export const Overlay = styled.div<{ $opened: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1005;
  background: rgba(0, 0, 0, 0.4);

  display: flex;
  align-items: center;
  justify-content: center;

  ${(p) =>
    p.$opened
      ? css`
          opacity: 1;
          animation: ${InAnimationOverlay} 150ms ease-out;
        `
      : css`
          opacity: 0;
          animation: ${OutAnimationOverlay} 150ms ease-out;
        `};
`

export const Box = styled.div<{ $opened: boolean }>`
  display: flex;
  flex-direction: column;
  position: relative;

  min-width: 500px;
  max-width: 90%;
  max-height: 95%;
  min-height: 200px;
  width: auto;
  height: auto;
  border-radius: 10px;
  overflow: hidden;

  box-shadow: var(--theme-boxShadows-offset-offset100Y4);

  ${(p) =>
    p.$opened
      ? css`
          opacity: 1;
          animation: ${InAnimationDialog} 250ms ease-out;
        `
      : css`
          opacity: 0;
          animation: ${OutAnimationDialog} 250ms ease-out;
        `};
`

export const Header = styled.header`
  height: 80px;
  min-height: 80px;
  position: relative;
  font: var(--theme-typography-h2-semiBold);
  color: var(--theme-colors-global-general-main);
  display: flex;
  align-items: center;
  padding: 0 32px;
  background: var(--theme-colors-theme-brand-primary);
`

export const HeaderLeft = styled.div`
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column;
`

export const HeaderAction = styled.div`
  margin-left: auto;
`

export const HeaderTitle = styled.h2`
  font: var(--theme-typography-h2-semiBold);
`

export const HeaderSubTitle = styled.h5`
  font: var(--theme-typography-h5-semiBold);
`

export const Content = styled.section<{ $withoutPadding: boolean }>`
  padding: ${(p) => (p.$withoutPadding ? '0' : '32px')};
  padding-top: ${(p) => (p.$withoutPadding ? '0' : '28px')};
  overflow-y: auto;
  position: relative;
  background: var(--theme-colors-global-general-main);
`

export const Footer = styled.footer`
  border-top: 1px solid var(--theme-colors-global-grey-grey300);
  background: var(--theme-colors-global-general-main);
  height: 77px;
  min-height: 77px;
  display: flex;
  align-items: center;
  padding: 0 32px;
`

export const FooterAction = styled.div`
  margin-left: auto;
`

export const CloseIcon = styled(IconV2)`
  transition: color 0.15s;
  position: absolute;
  top: 25px;
  right: 32px;
  cursor: pointer;
  color: var(--theme-colors-global-general-main);
  &:hover {
    color: var(--theme-colors-global-general-main);
  }
`
